import {MouseEventHandler, ReactElement, useCallback, useState} from "react";
import {useReactFlow, useViewport, XYPosition} from "react-flow-renderer";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
    content: {
        width: "100%",
        height: "100%"
    },
}));

interface IProps {
    children: ReactElement | ReactElement[]
}
export default function RightButtonPan({children}: IProps) {
    const classes = useStyles();
    const {x, y, zoom} = useViewport();
    const {setViewport} = useReactFlow();
    const [panning, setPanning] = useState(false);
    const [centerStartPos, setCenterStartPos] = useState<XYPosition>({x: 0, y: 0});
    const [eventStartPos, setEventStartPos] = useState<XYPosition>({x: 0, y: 0});
    const handleMouseDown: MouseEventHandler<HTMLElement> = useCallback((event) => {
        if (event.button === 2) {
            setPanning(true);
            setEventStartPos({x: event.clientX, y: event.clientY});
            setCenterStartPos({x, y});
        }
    }, [x, y]);
    const handleMouseUp: MouseEventHandler<HTMLElement> = useCallback(() => {
        if (panning) {
            setPanning(false);
        }
    }, [panning]);
    const handleMouseMove: MouseEventHandler<HTMLElement> = useCallback((event) => {
        if (panning) {
            const offsetX = eventStartPos.x - event.clientX
            const offsetY = eventStartPos.y - event.clientY;

            setViewport({x: centerStartPos.x - offsetX, y: centerStartPos.y - offsetY, zoom});
        }
    }, [centerStartPos, panning, setViewport, eventStartPos, zoom]);
    const handleContextMenu: MouseEventHandler<HTMLElement> = event => event.preventDefault();

    return (
        <div className={classes.content} onContextMenu={handleContextMenu} onMouseDown={handleMouseDown}
             onMouseLeave={handleMouseUp} onMouseMove={handleMouseMove} onMouseUp={handleMouseUp}>
            {children}
        </div>
    );
}